import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";

import { Button, TextFieldInput } from "@smart/itops-sb-design-system-dom";

import { MFAParams, mfaSchema } from "../hooks";

export type CodeProps = {
  label: string;
  onVerify: (params: MFAParams) => void;
};

export const Code = ({ label, onVerify }: CodeProps) => {
  const { register, handleSubmit } = useForm({
    resolver: zodResolver(mfaSchema),
    defaultValues: { code: "" },
  });

  return (
    <form
      className="relative my-[1rem] max-w-[80rem] w-[98%] flex flex-col gap-small"
      onSubmit={handleSubmit(onVerify)}
    >
      <TextFieldInput label={label} {...register("code")} autoFocus />
      <div className="flex justify-start">
        <Button type="submit" text="Verify" />
      </div>
    </form>
  );
};
